module.exports = new __parcel__URL__("meme-3.f8a4939f.png").toString();